module.exports = __webpack_public_path__ + "tinymce.aefbfcb02f143d3b3d3e.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/assets/skins/lightgray/fonts/tinymce.ttf
// module id = ../../../../../src/assets/skins/lightgray/fonts/tinymce.ttf
// module chunks = 3